const MARKET_SHIPPING_GROUPS = {
  'www.ohpolly.com': 'UK',
  'eu.ohpolly.com': 'Europe',
}

const shippingGroupName =
  MARKET_SHIPPING_GROUPS[window.location.hostname] || null

const selectShippingGroup = () => {
  const shippingGroups =
    window.orderDeadlineApp?.settings?.shippingGroups || []

  const shippingGroup = shippingGroups.find(
    (group) => group.name === shippingGroupName && group.enabled,
  )

  const shippingGroupId = shippingGroup?.id || null

  if (shippingGroupId) {
    window.orderDeadlineAppApi?.setSelectedShippingGroupId?.(shippingGroupId)
  }

  return shippingGroupId
}

window.BAO.orderDeadline = {
  isMappedMarket: Boolean(shippingGroupName),
  shippingGroupPromise: shippingGroupName
    ? new Promise((resolve) => {
      if (window.orderDeadlineAppApi) {
        resolve(selectShippingGroup())

        return
      }

      document.addEventListener(
        'orderDeadlineApp:api:ready',
        () => resolve(selectShippingGroup()),
        { once: true },
      )
    })
    : Promise.resolve(null),
}
